// Shared design system for every printed/PDF document (invoice, purchase bill,
// quotation, letter) — the SGP Office OS brand palette from the software spec,
// distinct from the app's internal teal UI because these are the documents a
// hospital, tender office, or supplier actually judges the company by.
export const DOC = {
  deepBlue: "#0B1F5C",
  sgpBlue: "#102E8C",
  actionBlue: "#1D43B8",
  gold: "#F5BE00",
  goldDark: "#B9860B",
  canvas: "#F5F7FB",
  ink: "#0F172A",
  slate: "#475569",
  border: "#CBD5E1",
};

export const RIBBON = {
  invoice: { bg: DOC.deepBlue, fg: "#FFFFFF", accent: DOC.gold },
  purchase: { bg: "#3F2D0B", fg: "#FDE9C4", accent: DOC.gold },
  quotation: { bg: "#3B2F00", fg: DOC.gold, accent: DOC.gold },
  letter: { bg: DOC.sgpBlue, fg: "#FFFFFF", accent: DOC.gold },
};
